import { AjaxTimeDataType } from '@vas2t-lowcode/utils';
import { AxiosPromise, AxiosRequestConfig } from 'axios';
import { getService } from '../config/get-service';
import { AxiosRequestConfigExtends } from '../entities/axios-request-config-extends';
import { RequestCustomConfigType } from '../entities/request-custom-config-type';

const HEADER_DEFAULT = {
  'Content-Type': 'application/x-www-form-urlencoded', // application/json
  Accept: 'application/json',
  // 'X-Requested-With': 'XMLHttpRequest',
};

const CUSTOM_CONFIG_DEFAULT = {
  /**
   * 显示错误信息
   */
  showRespErrMsg: true,
  /**
   * 需要跳转到登录页
   */
  toLoginPage: true,
  /**
   * 时间相关配置
   */
  timeData: {
    startTime: new Date(),
    // endTime?: Date,
    // timeMin?: number,
    // timeMax?: number,
  } as AjaxTimeDataType,
};

export function request<T>(url: string, options: AxiosRequestConfig, customConfig?: RequestCustomConfigType) {
  const headers = {
    ...HEADER_DEFAULT,
    ...(options?.headers || {}),
  };

  // 从 customConfig 获取超时时间, 否则默认5秒
  const timeout = customConfig?.timeout || 5000;

  const _options = {
    url,
    method: 'GET',
    headers,
    sslVerify: true,
    withCredentials: true, // 是否在跨域情况下发送 cookie
    timeout, // 请求超时时间
    data: {},
    ...options,
    customConfig: {
      ...CUSTOM_CONFIG_DEFAULT,
      ...customConfig,
    },
  } as AxiosRequestConfigExtends;
  const promise = getService()(_options) as AxiosPromise<T>;
  return promise;
}

export type ApiResponseDataType<T> = {
  result: string;
  data?: T;
  msg?: string;
};

export type { RequestCustomConfigType } from '../entities/request-custom-config-type';
